import { useIntl } from 'react-intl'
import { styled } from 'styled-components'

import { useDecodedAccessToken } from '@b-stock/fe-core/bstock-next/components'
import { useFlag } from '@b-stock/fe-core/bstock-next/helpers'
import {
  type OrchestratedOfferingListingDetails,
  type OrchestratedAuctionListingDetails,
} from '@b-stock/fe-core/bstock-next/queries'
import { Accordion, FormattedMessage } from '@b-stock/fe-core/bstock-react'
import { Breakpoints, Typography } from '@b-stock/fe-core/design-system'

import { FeatureFlags } from '@/helpers/featureFlags'

import { Title } from '../../shared'
import { LotDescription } from './LotDescription'

const TabletMobileOnlyWrapper = styled.div`
  /* Hide on desktop (larger than tablet) */
  @media ${Breakpoints.min.large} {
    display: none;
  }

  /* Mobile: Style accordion labels with Title2 */
  > div > div:first-child {
    ${Typography.Title2}
  }

  @media ${Breakpoints.min.medium} and ${Breakpoints.max.medium} {
    /* Tablet: Show content normally without accordion */
    > div > div:first-child {
      display: none; /* Hide accordion header */
    }
    > div > div:last-child {
      height: auto !important;
      overflow: visible !important;
      padding: 0 !important;
    }
  }
`

export const ListingLotDescriptionSection = ({
  listing,
}: {
  listing:
    | OrchestratedOfferingListingDetails
    | OrchestratedAuctionListingDetails
}) => {
  const { formatMessage } = useIntl()
  const personId = useDecodedAccessToken()?.personId
  const enableLdpRedesign = useFlag(FeatureFlags.ENABLE_LDP_REDESIGN)

  if (enableLdpRedesign || !personId || !listing.lot.description) {
    return null
  }

  return (
    <TabletMobileOnlyWrapper>
      <Accordion
        label={formatMessage({ id: 'Auction.title.description' })}
        isOpen
      >
        <Title>
          <FormattedMessage id="Auction.title.description" />
        </Title>
        <LotDescription description={listing.lot.description} />
      </Accordion>
    </TabletMobileOnlyWrapper>
  )
}
